import { AxiosResponse } from "axios";
import { oc } from "ts-optchain";
import { Nullable } from "@/types";

import { DealernetApi } from "./DealernetApi";

import { IAccountContext, IPagedList, IPartListDto, IPartListItemDto, IPartListSummaryDto } from "@/types";

const CONTROLLER_PATH = "PartList";

export class PartListService {
  public static async GetPartListSummary(params: IGetPartListSummaryRequest): Promise<IPartListSummaryDto[]> {
    const response = await DealernetApi.client().request({
      method: "get",
      url: `${CONTROLLER_PATH}/PartListSummary`,
      params,
    });

    return oc(response as AxiosResponse<IPartListSummaryDto[]>).data([]);
  }

  public static async CreateNewPartList(params: ICreateNewPartListRequest): Promise<IPartListDto> {
    const response = await DealernetApi.client().request({
      method: "get",
      url: `${CONTROLLER_PATH}/CreatePartList`,
      params,
    });

    return oc(response as AxiosResponse<IPartListDto>).data()!;
  }

  public static async AddPartListItems(request: IAddPartListItemsRequest): Promise<IPagedList<IPartListItemDto>> {

    const { partListItems, ... params } = request;

    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/AddPartListItems`,
      data: partListItems,
      params
    });

    return oc(response as AxiosResponse<IPagedList<IPartListItemDto>>).data()!;
  }

  public static async DeletePartList(params: IDeletePartListRequest): Promise<boolean> {
    const response = await DealernetApi.client().request({
      method: "delete",
      url: `${CONTROLLER_PATH}/DeletePartList`,
      params,
    });

    return oc(response as AxiosResponse<boolean>).data()!;
  }

  public static async ClearActivePartLists(params: IClearActivePartListsRequest): Promise<boolean> {
    const response = await DealernetApi.client().request({
      method: "delete",
      url: `${CONTROLLER_PATH}/ClearActivePartLists`,
      params,
    });

    return oc(response as AxiosResponse<boolean>).data()!;
  }
  
  public static async RenameList(params: IRenamePartListRequest): Promise<any> {
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/RenamePartList`,
      params,
    });

    return oc(response as AxiosResponse<any>).data()!;
  }

  public static async GetCustomerSku(params: IGetCustomerSkuRequest): Promise<ICustomerSkuDto[]> {
    const response = await DealernetApi.client().request({
      method: "get",
      url: `${CONTROLLER_PATH}/GetCustomerSkus?accountId=${params.accountId}&oemPartCode=${params.oemPartCode}`
  });

    return oc(response as AxiosResponse<ICustomerSkuDto[]>).data()!;
  }

  public static async SaveCustomerSku(params: ICustomerSkuDto): Promise<ICustomerSkuDto> {
    const response = await DealernetApi.client().post(`${CONTROLLER_PATH}/SaveCustomerSku`, params);
    return oc(response as AxiosResponse<ICustomerSkuDto>).data()!;
  }
}

// tslint:disable-next-line: no-empty-interface
export interface IGetPartListSummaryRequest extends IAccountContext {
  numberItemsToReturn: number;
}

export interface ICreateNewPartListRequest extends IAccountContext {
  partListName: string;
}

export interface IRenamePartListRequest extends IAccountContext {
  partListId: number;
  newName: string;
}

export interface IAddPartListItemsRequest extends IAccountContext {
  partListId: number;
  dealerCode: string;
  partListItems: IPartListItemDto[];
}

export interface IDeletePartListRequest extends IAccountContext {
  partListId: number;
}

export interface IClearActivePartListsRequest extends IAccountContext {
  accountId: number;
  userId: number;
}

export interface IGetCustomerSkuRequest {
  accountId: number;
  oemPartCode: string;
}

export interface ICustomerSkuDto {
    Id: Nullable<number>;
    AccountId: number;
    OemPartCode: string;
    CustomerSku: string;
    IsPrimary: Boolean;
}